import {formatFieldAsText, strip} from '@/common/questionsExporter/utility'

const hotspotQuestion = (question) => {
    const strippedPrompt = strip(question.question)
    const clues = question.clues ? question.clues : []
    const formattedClues = clues.map(formatFieldAsText).join("\n")

    return `${strippedPrompt}\nClues:\n${formattedClues}`
}

export {hotspotQuestion}
